import type { DataOf } from '@elara/firebolt/shared';

import { z } from 'zod';

import { collectionPath, defineModelSpec } from '@elara/firebolt/shared';
import { zFirestampOptional } from '@elara/firebolt/zod-types';

import { GalleryImageSchema } from './schemas/image-schemas.js';
import { hotelId, id } from './schemas/zod-types.js';

/**
 * Fixed document id of the single gallery doc per hotel: `hotels/{hotelId}/media/gallery`.
 * One doc holds the full photo set so the client fetches the whole gallery in one read.
 */
export const HOTEL_MEDIA_GALLERY_DOC_ID = 'gallery';

/**
 * The canonical `ModelSpec` for the per-hotel media subcollection (`hotels/{hotelId}/media/{id}`).
 * Holds the full provider photo set (unbounded — the head doc's `images` carries only the first
 * ~10 for cards). Sources are never merged: the whole gallery comes from exactly one provider,
 * recorded in `source`. Server-written only; the subcollection is invisible to the staging
 * differ, so publishing hotel content can never clobber photos.
 */
export const HotelMediaModelSpec = defineModelSpec({
  path: collectionPath`hotels/${hotelId}/media/${id}`,
  shape: {
    /** Provider that supplied this gallery (open string: "sabre", "travelport", ... or "none"). */
    source: z.string(),
    fetchedAt: zFirestampOptional(),
    images: z.array(GalleryImageSchema),
  },
  constraints: [],
});

export type HotelMediaModelSpec = typeof HotelMediaModelSpec;
export interface HotelMediaGallery extends DataOf<HotelMediaModelSpec> {}
